import { motion } from 'framer-motion';
import { testimonials } from '../data/testimonials';

export default function Testimonials() {
  return (
    <section className="container-page py-20 md:py-28">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="max-w-2xl"
      >
        <p className="eyebrow">What clients say</p>
        <h2 className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight text-white md:text-4xl">
          The kind of feedback we work to earn.
        </h2>
      </motion.div>

      <div className="mt-12 grid gap-5 md:grid-cols-3">
        {testimonials.map((t, i) => (
          <motion.figure
            key={i}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-40px' }}
            transition={{ duration: 0.5, delay: i * 0.06 }}
            className="card flex h-full flex-col justify-between"
          >
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="h-6 w-6 text-accent-400/70"
                aria-hidden="true"
              >
                <path d="M7.17 6A5.001 5.001 0 002 11v7h7v-7H4.5a2.5 2.5 0 012.67-2.5V6zm10 0a5.001 5.001 0 00-5.17 5v7h7v-7h-4.5a2.5 2.5 0 012.67-2.5V6z" />
              </svg>
              <blockquote className="mt-4 text-sm leading-relaxed text-white/80 md:text-base">
                {t.quote}
              </blockquote>
            </div>
            <figcaption className="mt-6 border-t border-white/10 pt-4">
              <p className="text-sm font-medium text-white">{t.author}</p>
              <p className="mt-0.5 text-xs text-white/55">
                {t.role}
                {t.company ? ` · ${t.company}` : ''}
              </p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
